
      module.exports = {
        functional: true,
        render(_h, _vm) {
          const { _c, _v, data, children = [] } = _vm;

          const {
            class: classNames,
            staticClass,
            style,
            staticStyle,
            attrs = {},
            ...rest
          } = data;

          return _c(
            'svg',
            {
              class: [classNames,staticClass],
              style: [style,staticStyle],
              attrs: Object.assign({"viewBox":"0 0 136 136","xmlns":"http://www.w3.org/2000/svg"}, attrs),
              ...rest,
            },
            children.concat([_c('path',{attrs:{"fill-rule":"evenodd","clip-rule":"evenodd","d":"M69.889 72.486h8.264v-8.264h-8.264v8.264zm24.791-8.264h8.264v8.264H94.68v-8.264zm28.924 41.32v-8.264h-4.132V39.43c0-4.546-3.719-8.264-8.264-8.264H61.625c-4.545 0-8.264 3.718-8.264 8.264v57.847h-4.132v8.264h74.375zm-61.98-66.111h20.66v57.847h-20.66V39.43zm28.925 0h20.659v57.847h-20.66V39.43zm-52.3 11.923c0 3.117-2.55 5.667-5.666 5.667-3.116 0-5.666-2.55-5.666-5.667s2.55-5.666 5.666-5.666c3.117 0 5.667 2.55 5.667 5.666zm-24.082 55.25l7.933-39.95-5.1 1.984v9.633h-5.667V64.954l14.309-6.063c2.748-1.162 5.921-.142 7.508 2.38l2.833 4.533c2.267 3.967 6.8 6.8 12.184 6.8v5.667c-6.234 0-11.9-2.834-15.584-7.084l-1.7 8.5 5.95 5.667v21.25h-5.666v-17l-5.95-5.666-5.1 22.666h-5.95z","fill":"#0095DA"}})])
          )
        }
      }
    